/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ProviderDocumentType {

    DATA_SHEET = 'DATA_SHEET',

    WHITEPAPER = 'WHITEPAPER',

    SECURITY_REPORT = 'SECURITY_REPORT',

    CASE_STUDY = 'CASE_STUDY',

    MANUAL = 'MANUAL',

    OTHER = 'OTHER'
}

